// Storage keys are namespaced so multiple Bytz apps can coexist on the same
// origin without colliding (e.g. admin + storefront on staging).
export const STORAGE_NAMESPACE = 'bytz';

export const AUTH_STORAGE_KEY = `${STORAGE_NAMESPACE}.auth`;
export const STORE_CONTEXT_STORAGE_KEY = `${STORAGE_NAMESPACE}.storeContext`;
export const ACCOUNT_SELECTION_STORAGE_KEY = `${STORAGE_NAMESPACE}.accountSelection`;
export const GUEST_SESSION_STORAGE_KEY = `${STORAGE_NAMESPACE}.guestSession`;
export const MERCHANT_STORAGE_KEY = `${STORAGE_NAMESPACE}.merchant`;

// Refresh proactively when access token has this much (or less) life left.
export const REFRESH_THRESHOLD_MS = 60_000;

export const OTP_PURPOSE = Object.freeze({
  SIGNUP: 'signup',
  RESET_PASSWORD: 'reset_password',
});

// Thrown by the api client when the refresh token is dead and the customer has
// been signed out. UI toasts skip this error — the login modal opens instead.
export const SESSION_EXPIRED_CODE = 'session_expired';
export const SESSION_EXPIRED_MESSAGE = 'Session expired';
